// extracted by mini-css-extract-plugin
export default {"main":"Initial_main__mHWKP","child":"Initial_child__T7y7L"};